import { render, staticRenderFns } from "./UploadQuoteXLSB.vue?vue&type=template&id=31055f16&"
import script from "./UploadQuoteXLSB.js?vue&type=script&lang=js&"
export * from "./UploadQuoteXLSB.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports